import React, { Component } from 'react';
import Validacoes from '../../libs/Validacoes';
import API from './../../API/Api';
import './FormCliente.css'
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IoMdArrowBack } from "react-icons/io"
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Redirect, withRouter } from 'react-router-dom';
import services from './../../services/index';
import Loading from './../loading/Loading';
import Spinner from './../spinner/Spinner'
import { IoIosAdd, IoMdCreate, IoIosCloseCircle, IoMdTrash } from "react-icons/io"
import IconButton from '@material-ui/core/IconButton';
import ButtonMaterial from '@material-ui/core/Button';
import { isEmpty, isObject } from "lodash"

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"



import { CardAdress, ContainerRow, TitleEnderco, ContainerAdress } from "./style"


class FormCliente extends Component {

	constructor(props) {
		super(props);
		this.nameRef = React.createRef();
	}


	state = {
		nome: '',
		email: '',
		cpf: '',
		dt_nascmimento: '',
		ddd: '',
		telefone: '',
		senha: '',
		loading: false,
		logradouro: '',
		numero: '',
		bairro: '',
		cidade: '',
		estado: '',
		cep: '',
		complemento: '',
		ponto_referencia: '',
		descricao: '',
		showAlertSucces: false,
		textAlertSucces: '',
		showAlertError: false,
		textAlertError: '',
		redirec: false,
		isEdit: false,
		loadingPage: false,
		id_cliente: 0,
		longitude: 0,
		latitude: 0,
		adressSelect: { name: 'Teste', code: 1 },
		searchCep: false,
		hiddenAdress: false,
		allAdress: [],
		isLogado: false,
		adressInEdit: false,
		registeringNewAdress: false,
		oldAdress: {},
		currentIDEndereco: 0,
		enderecoPrincipal: false,
		goTo: 0
	};


	componentDidMount() {
		this.InitApp();
		let objAdress = null;

		try {
			const aux = this.props.match.params.objAdress;
			objAdress = JSON.parse(aux)
		} catch (error) {
			console.log(error)
			objAdress = {}
		}

		if (objAdress.ogot) {
			return this.setState({ goTo: objAdress.ogot });
		}

		if (objAdress && !isEmpty(objAdress)) {
			try {
				const obj = objAdress;
				this.setState({
					cep: obj.cep
				}, () => {
					this.handleCep();
				});

			} catch (error) {
			}
		}
	}



	InitApp = async () => {
		this.setState({ loadingPage: true });
		try {
			const isLogado = await services.isLogado()
			if (isLogado) {
				let info = services.getUser();
				let user = info.dados_cli;

				user.endereco = info.enderecos[0];

				if (isObject(user.endereco) && !isEmpty(user.endereco)) {

					this.setState({ hiddenAdress: true, allAdress: info.enderecos })
				}

				this.preencheCampos(user);
				this.setState({ isLogado: true })
			}
			this.setState({ loadingPage: false });
		} catch (error) {
			this.setState({ loadingPage: false });
		}
	}






	preencheCampos = (user) => {
		const { endereco } = user;

		this.setState({
			nome: user.nome_completo,
			cpf: user.cpf,
			email: user.email,
			ddd: user.ddd1,
			telefone: user.telefone1,
			senha: 'naoalterousenha**',
			cep: endereco.cep,
			logradouro: endereco.logradouro,
			numero: endereco.numero,
			bairro: endereco.bairro,
			complemento: endereco.complemento || '',
			estado: endereco.estado,
			cidade: endereco.cidade,
			ponto_referencia: endereco.ponto_referencia,
			isEdit: true,
			descricao: endereco.descricao,
			latitude: endereco.latitude,
			longitude: endereco.longitude,
			enderecoPrincipal: endereco.principal,
			id_cliente: user.id_cliente
		});
	}


	logIn = async (email, password) => {
		const dataLogin = { email, password }

		try {
			let headers = { "Content-Type": " application/json" }
			const response = await API.post('login', dataLogin, { headers: headers });

			if (response.status === 200) {

				this.props.setUserLogado(response.data.dados_cli);
				this.props.setAdressUser(response.data.enderecos);
				services.setUser(JSON.stringify(response.data))

				services.setLogado(true);

				return true;
			}

			return false;

		} catch (error) {
			return false;
		}
	}


	redireciona = async (fromCad) => {

		if (this.props.match.params.objAdress) {
			if (await this.logIn(this.state.email, this.state.senha)) {
				return this.props.history.goBack();
			} else {
				alert('Ops... Algo deu errado');
			}
		}
		this.props.history.goBack();
	}

	handleCadCli = async (e) => {

		e.preventDefault();
		if (e.keyCode === 13) {
			return;
		}

		// Aqui começa o consumo da API
		if (this.validaCampos()) {

			// Chama API Passando os caras  no body
			const { nome: nome_completo, cpf, email, senha, telefone, ddd, id_cliente,
				logradouro, numero, bairro, cidade, estado, cep, complemento,
				ponto_referencia, latitude, longitude, descricao, adressInEdit, currentIDEndereco,
				enderecoPrincipal
			} = this.state;


			let endereco = {};

			if (id_cliente > 0 && adressInEdit) {
				endereco = {
					logradouro: logradouro,
					numero: numero,
					bairro: bairro,
					cidade: cidade,
					estado: estado,
					cep: cep,
					complemento: complemento,
					ponto_referencia: ponto_referencia,
					latitude: latitude,
					longitude: longitude,
					descricao: descricao,
					id_endereco: currentIDEndereco,
					enderecoPrincipal: enderecoPrincipal,
				}
			} else if (id_cliente > 0 && !adressInEdit) {
				endereco = {};
			} else if (id_cliente === 0) {
				endereco = endereco = {
					logradouro: logradouro,
					numero: numero,
					bairro: bairro,
					cidade: cidade,
					estado: estado,
					cep: cep,
					complemento: complemento,
					ponto_referencia: ponto_referencia,
					latitude: latitude,
					longitude: longitude,
					descricao: descricao,
					enderecoPrincipal: enderecoPrincipal
				}
			}


			let data = {
				nome_completo: nome_completo,
				cpf: cpf,
				email: email,
				senha: senha,
				telefone: telefone,
				ddd: ddd,
				id_cliente: id_cliente,
				endereco
			}


			let headers = {};

			if (id_cliente > 0) {
				headers = services.getHeadersAndCli().headers;
			} else {
				headers = { "Content-Type": " application/json" };
			}


			this.loading(true);

			try {


				const response = await API.put('cliente', data, { headers });

				var dataLogin = {
					email: data.email,
					password: data.senha
				}

				if (!this.state.isEdit) {
					var login = await API.post('login', dataLogin, { headers: headers });
					if (login.status === 200) {
						services.setUser(JSON.stringify(login.data))
						this.redireciona();
					}
					this.resolveAlert('Cadastro efetudo.', false);
				} else {
					// Tem que atualizar as informaçoes do cliente 
					services.atualizaInfoCliLogado(data);

					if (this.props.handleChange) {
						this.props.handleChange();
					}
					await this.InitApp();
					this.setState({ adressInEdit: false });
					this.resolveAlert('Cadastro Atualizado.', false);

				}

				this.loading(false);

			} catch (error) {
				this.loading(false);
				if (error.response) {
					//	console.log(response);
					if (error.response['data']) {
						if (error.response.status === 409 && error.response.data.message === 'Duplicate register') {
							this.resolveAlert('Parece que já temos um cadastro com o mesmo E-mail ou CPF', true);
						} else if (error.response.status === 500) {
							this.resolveAlert('Alguma coisa ocorreu fora do normal. Tente novamente, por favor.', true);
						}
					} else {
						this.resolveAlert('Alguma coisa ocorreu fora do normal. Tente novamente, por favor.', true);
					}
				} else {
					this.resolveAlert('Parece que estamos fora do ar. Por favor, tente novamente mais tarde.', true);
				}

			}
		}

	}




	deleteAdress = async (indexAdress) => {
		try {
			this.setState({ loadingPage: true });

			const adress = this.state.allAdress[indexAdress];

			const itWasPrincipal = this.state.allAdress[indexAdress].principal;

			if (this.state.allAdress.length === 1) {
				this.setState({ loadingPage: false })
				return this.resolveAlert('Não é possível excluir o único endereço', true);
			}

			const response = await services.deleteAdress({
				id_endereco: adress.id_endereco
			});

			this.setState({ loadingPage: false });



			if (response.status === 200) {

				const user = services.getUser();
				const enderecos = user.enderecos.filter(e => e.id_endereco !== adress.id_endereco);

				if (itWasPrincipal) {
					user.enderecos[0].principal = true;
				}

				user.enderecos = enderecos;

				services.setUser(JSON.stringify(user));

				this.setState({ allAdress: enderecos });

				if (this.props.handleChange) {
					this.props.handleChange();
				}

				this.resolveAlert('Registro excluído.');
				return;
			} else {
				if (response.status === 1200) {
					return this.resolveAlert('Não é possível excluir endereço, pois o mesmo já foi usado em algum pedido.', true);
				}
			}

			this.resolveAlert('Ops... Algo deu errado', true)

			this.setState({ loadingPage: false });
		} catch (error) {
			this.setState({ loadingPage: false });
		}
	}



	putAdressInEdit = (indexAdress) => {
		const adress = this.state.allAdress[indexAdress];


		this.setState({
			cep: adress.cep,
			logradouro: adress.logradouro,
			numero: adress.numero,
			bairro: adress.bairro,
			complemento: adress.complemento || '',
			estado: adress.estado,
			cidade: adress.cidade,
			ponto_referencia: adress.ponto_referencia,
			hiddenAdress: false,
			descricao: adress.descricao,
			adressInEdit: true,
			currentIDEndereco: adress.id_endereco,
			enderecoPrincipal: adress.principal
		});
	}


	putAnNewAdress = () => {
		this.setState({
			cep: '',
			logradouro: '',
			numero: '',
			bairro: '',
			complemento: '',
			estado: '',
			cidade: '',
			ponto_referencia: '',
			hiddenAdress: false,
			descricao: '',
			registeringNewAdress: true,
			enderecoPrincipal: false,
			oldAdress: {
				cep: this.state.cep,
				numero: this.state.numero,
				bairro: this.state.bairro,
				complemento: this.state.complemento,
				estado: this.state.estado,
				cidade: this.state.cidade,
				ponto_referencia: this.state.ponto_referencia,
				descricao: this.state.descricao,
				logradouro: this.state.logradouro,
				enderecoPrincipal: this.state.enderecoPrincipal
			}
		});
	}



	closeAdressEdit = () => {
		if (!this.state.adressInEdit) {
			this.setState({
				hiddenAdress: true,
				adressInEdit: false,
				registeringNewAdress: false,
				cep: this.state.oldAdress.cep,
				numero: this.state.oldAdress.numero,
				bairro: this.state.oldAdress.bairro,
				complemento: this.state.oldAdress.complemento,
				estado: this.state.oldAdress.estado,
				cidade: this.state.oldAdress.cidade,
				ponto_referencia: this.state.oldAdress.ponto_referencia,
				descricao: this.state.oldAdress.descricao,
				logradouro: this.state.oldAdress.logradouro,
				enderecoPrincipal: this.state.enderecoPrincipal
			})
		} else {
			this.setState({
				hiddenAdress: true,
				adressInEdit: false,
			})
		}
	}



	logaIn = async () => {
		const dataLogin = { email: this.state.email, password: this.state.senha }

		try {
			let headers = { "Content-Type": " application/json" }
			const response = await API.post('login', dataLogin, { headers: headers });

			this.loading(false);

			if (response.status === 200) {

				this.props.setUserLogado(response.data.dados_cli);
				this.props.setAdressUser(response.data.enderecos);
				services.setUser(JSON.stringify(response.data))

				services.setLogado(true);

				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}


	atualizaDadosLocais = () => {
		let user = services.getUser();
		if (user) {
			user = JSON.parse(user);
		}
	}

	handleCPF = (e) => {
		if (e.target.validity.valid)
			this.setState({ [e.target.name]: e.target.value });
	}

	handleDDD = (e) => {
		if (e.target.validity.valid)
			this.setState({ [e.target.name]: e.target.value });
	}

	handleTelefone = (e) => {
		if (e.target.validity.valid)
			this.setState({ [e.target.name]: e.target.value });
	}



	handleAllInputs = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	}


	handleCep = async () => {
		this.setState({ searchCep: true });
		let cep = this.state.cep;

		this.setState({
			logradouro: '', complemento: '', bairro: '', cidade: ''
			, estado: ''
		});


		if (Validacoes.validaCEP(cep)) {
			//let url_consulta = `https://viacep.com.br/ws/${cep}/json/`;
			try {
				// const response = await fetch(url_consulta)
				// const rCep = await response.json();

				const response = await services.getCep(cep);

				if (!response.logradouro) {
					//this.resolveAlert('Cep inválido', true);

					this.setState({ searchCep: false });
					this.resolveAlert('Cep inválido', true);
					return
				}

				this.setState({
					logradouro: response.logradouro, complemento: '', bairro: response.bairro, cidade: response.localidade
					, estado: response.estado, longitude: response.longitude, latitude: response.latitude, cidade: response.cidade
				});

				this.setState({ searchCep: false });

			} catch (e) {
				this.setState({ searchCep: false });
				console.log(e);

			}

		} else {
			this.setState({ searchCep: false });
			this.resolveAlert('Cep inválido', true);

			return false
		}



	}


	validaCampos = () => {
		const { nome, email, cpf, ddd, telefone, senha, logradouro, numero, bairro,
			cidade, estado, cep, descricao
		} = this.state;


		if (!nome || !email || !cpf || !ddd || !telefone || !senha || !logradouro || !descricao ||

			!numero || !bairro || !cidade || !estado || !cep) {
			this.resolveAlert('Campos obrigatórios não preenchidos', true);
			return false;
		}


		if (!Validacoes.validaCPF(cpf) || !cpf) {
			this.resolveAlert('CPF Inválido', true);

			return false;
		}

		if (!Validacoes.validaEMAIL(email) || !email) {
			this.resolveAlert('E-MAIL Inválido', true);
			return false;
		}

		if (!ddd || !telefone || !senha || !nome) {
			this.resolveAlert('Dados Obrigatórios não preenchidos', true);
			return false;
		}


		if (!logradouro || !numero || !bairro || !cidade || !estado || !cep) {
			this.resolveAlert('Campos obrigatórios não preenchidos', true);
			return;
		}

		return true;
	}


	handleCloseAll = () => {
		let isError = this.state.showAlertError;
		this.setState({ showAlertError: false, showAlertSucces: false, textAlertError: '', textAlertSucces: '' }, () => {
			if (this.state.isEdit && !isError) {
				this.setState({ redirec: false });
			}
		});
	}

	loading = (status) => {
		if (status) {
			this.setState({ loading: true })
		} else {
			this.setState({ loading: false });
		}
	}

	resolveAlert = (text, danger) => {
		if (text) {
			if (danger) {
				this.setState({ showAlertError: true, textAlertError: text });
			} else {
				this.setState({ showAlertSucces: true, textAlertSucces: text })
			}
		}
	}

	resolveSubmit = (e) => {
		e.preventDefault();
		return;
	}





	registerAdress = async () => {
		try {
			const body = {
				id_cliente: this.state.id_cliente,
				endereco: {
					cep: this.state.cep,
					numero: this.state.numero,
					bairro: this.state.bairro,
					complemento: this.state.complemento,
					estado: this.state.estado,
					cidade: this.state.cidade,
					ponto_referencia: this.state.ponto_referencia,
					descricao: this.state.descricao,
					logradouro: this.state.logradouro,
					longitude: this.state.longitude,
					latitude: this.state.latitude,
					enderecoPrincipal: this.state.enderecoPrincipal
				}
			};

			const response = await services.registerAdress(body);

			if (response.status === 200) {
				let user = services.getUser();
				body.endereco.id_endereco = response.id_endereco;
				user.enderecos.push(body.endereco);
				services.setUser(JSON.stringify(user));

				this.setState({
					allAdress: user.enderecos,
					hiddenAdress: true,
					registeringNewAdress: false
				})

				this.resolveAlert('Cadastro Concluído');
			} else {
				this.resolveAlert('Ops... Algo deu errado.');
			}

		} catch (error) {
			this.resolveAlert('Ops... Algo deu errado.');
		}
	}





	handleEnderecoPrincipal = () => {
		this.setState({ enderecoPrincipal: !this.state.enderecoPrincipal });
	}











	render() {
		const { allAdress, hiddenAdress } = this.state;

		if (this.state.loadingPage) {
			return <Loading />
		}


		return (

			<div className="container content-login">

				<div className="content-alerts">
					{this.state.showAlertError ? <div className="alert alert-danger alert-custom" role="alert"><p>{this.state.textAlertError}</p></div> : ''
					}
				</div>
				<div className="box-login box-cad">

					<div className="row">
						<div className="container container-box-cad">

							<div className="col-md-12 ">
								<div className="back-cad"><IoMdArrowBack onClick={this.redireciona} icon={faArrowLeft} className="pull-left" /></div>
								<h2>Dados Pessoais</h2>


								{/* onsubmit="return false;"
                                    onSubmit={this.handleCadCli} */}
								<form onSubmit={this.resolveSubmit} className="frmCadCli">
									<div className="row">
										<div className="col-md-4">
											<div className="form-group">
												<label>Nome Completo *</label>
												<input ref={this.nameRef} type="text" className="form-control yellowOutline" name="nome" value={this.state.nome} onChange={this.handleAllInputs} />
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label>CPF *</label>

												{
													this.state.isEdit ? (<input type="text" className="form-control yellowOutline" maxLength="11" pattern="[0-9]*" name="cpf" value={this.state.cpf} onChange={this.handleCPF} disabled />)
														: (<input type="text" className="form-control yellowOutline" maxLength="11" pattern="[0-9]*" name="cpf" value={this.state.cpf} onChange={this.handleCPF} />)
												}


											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label>E-mail *</label>
												<input type="email" className="form-control yellowOutline" name="email" value={this.state.email} onChange={this.handleAllInputs} />

											</div>
										</div>
									</div>

									<div className="row">

										<div className="col-md-1">
											<div className="form-group">
												<label>DDD *</label>
												<input type="tel" className="form-control yellowOutline" pattern="[0-9]*" name="ddd" maxLength="2" value={this.state.ddd} maxLength="2" onChange={this.handleDDD} />
											</div>
										</div>

										<div className="col-md-3">
											<div className="form-group">
												<label>Telefone *</label>
												<input type="tel" className="form-control yellowOutline" pattern="[0-9]*" maxLength="9" name="telefone" value={this.state.telefone} onChange={this.handleTelefone} />
											</div>
										</div>

										<div className="col-md-8">
											<div className="form-group">
												<label>Senha *</label>
												<input type="password" className="form-control yellowOutline" name="senha" value={this.state.senha} onChange={this.handleAllInputs} />
											</div>
										</div>
									</div>








									<ContainerRow>
										<TitleEnderco>Endereço</TitleEnderco>
										{this.state.isLogado && !this.state.registeringNewAdress && !this.state.adressInEdit && <IconButton onClick={this.putAnNewAdress}>
											<IoIosAdd color="#000" size={26} />
										</IconButton>}
									</ContainerRow>

									{!hiddenAdress && <ContainerAdress>
										{this.state.isLogado && <IconButton className="closeEditAdress" onClick={this.closeAdressEdit}>
											<IoIosCloseCircle color="#000" size={26} />
										</IconButton>}
										<div className="row">
											<div className="col-md-3">
												<div className="form-group">
													<label>Cep * &nbsp;
                                                        {
															this.state.searchCep ? <img src="assets/25.gif" /> : ''
														}

													</label>

													<input ref={this.textInput} type="text" maxLength="8" id="inputCep" className="form-control yellowOutline" onBlur={this.handleCep} name="cep" value={this.state.cep} onChange={this.handleAllInputs} />

												</div>

											</div>

											<div className="col-md-6">
												<div className="form-group">
													<label>Logradouro *</label>
													<input type="text" disabled className="form-control yellowOutline" name="logradouro" value={this.state.logradouro} onChange={this.handleAllInputs} />
												</div>
											</div>

											<div className="col-md-3">
												<div className="form-group">
													<label>Numero *</label>
													<input type="text" className="form-control yellowOutline" name="numero" value={this.state.numero} onChange={this.handleAllInputs} />
												</div>
											</div>
										</div>

										<div className="row">



											<div className="col-md-6">
												<div className="form-group">
													<label>Bairro *</label>
													<input type="text" className="form-control yellowOutline" disabled name="bairro" value={this.state.bairro} maxLength="2" onChange={this.handleAllInputs} />
												</div>
											</div>

											<div className="col-md-6">
												<div className="form-group">
													<label>Complemento </label>
													<input type="text" className="form-control yellowOutline" name="complemento" value={this.state.complemento} onChange={this.handleAllInputs} />
												</div>
											</div>

										</div>

										<div className="row">
											<div className="col-md-2">
												<div className="form-group">
													<label>Estado *</label>
													<input type="text" className="form-control yellowOutline" disabled name="estado" value={this.state.estado} onChange={this.handleAllInputs} />
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<label>Cidade *</label>
													<input type="text" className="form-control yellowOutline" disabled name="cidade" value={this.state.cidade} onChange={this.handleAllInputs} />
												</div>
											</div>


											<div className="col-md-6">
												<div className="form-group">
													<label>Ponto de Referência </label>
													<input type="text" className="form-control yellowOutline" name="ponto_referencia" value={this.state.ponto_referencia} onChange={this.handleAllInputs} />
												</div>
											</div>
										</div>



										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<label>Descrição *</label>
													<input
														type="text"
														className="form-control yellowOutline"
														name="descricao"
														value={this.state.descricao}
														onChange={this.handleAllInputs}
														disabled={this.state.adressInEdit}
													/>
												</div>
											</div>

											{/* <div className="col-col-md-3">
												<label style={{ marginTop: 30, marginLeft: 20 }}>
													<input
														type="checkbox"
														name="enderecoPrincipal"
														style={{ marginRight: 10 }}
														disabled={!this.state.isEdit || this.state.registeringNewAdress}
														checked={(!this.state.isEdit && true) || this.state.enderecoPrincipal}
														onChange={this.handleEnderecoPrincipal}
													/>
														Endereço Principal
													</label>
											</div> */}

											{this.state.registeringNewAdress && <div className="col-md-3 col-sm-3 col-xs-12">
												<ButtonMaterial onClick={this.registerAdress} type="button" className="btnCadastrar btnAtualizarEndereco">
													Cadastrar Endereço
												</ButtonMaterial>
											</div>}
										</div>
									</ContainerAdress>}



									{
										hiddenAdress && (
											<>
												{
													allAdress && allAdress.length > 0 && allAdress.map((ad, index) => {

														return (
															<CardAdress key={index}>
																<h5 style={{ margin: 0, padding: 0 }}>{ad.logradouro}, {ad.numero}, {ad.cidade} - {ad.estado}</h5>
																{/* {(ad.principal === 1 || ad.principal === true) ? <h2 style={{ fontSize: 14, color: '#0BB586' }}>Principal</h2> : null} */}
																<div>
																	<IconButton onClick={() => this.deleteAdress(index)}>
																		<IoMdTrash color="#000" />
																	</IconButton>
																	<IconButton onClick={() => this.putAdressInEdit(index)}>
																		<IoMdCreate color="#000" />
																	</IconButton>
																</div>
															</CardAdress>
														)
													})
												}
											</>
										)
									}





									<div className="row">
										<div className="col-md-5">
											{!this.state.loading ? (
												<div>
													{
														!this.state.registeringNewAdress && <ButtonMaterial type="button" className="btnCadastrar" disabled={this.state.searchCep} onClick={this.handleCadCli}>
															{this.state.isEdit ? 'ATUALIZAR CADASTRO' : 'CADASTRAR'}
														</ButtonMaterial>
													}
												</div>
											) : <Spinner size="less" />
											}
										</div>

										<div className="col-md-6">

										</div>
									</div>




								</form>
							</div>
						</div>
					</div>
				</div>



				<Modal show={this.state.showAlertError} onHide={this.handleCloseAll}>
					<Modal.Header style={{ background: '#EACACA' }} closeButton>
						<Modal.Title style={{ color: '#C6807F' }}>Ops... Algo deu errado</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ background: '#EACACA' }}>
						<p>{this.state.textAlertError}</p>
					</Modal.Body>
					<Modal.Footer style={{ background: '#EACACA' }}>
						<Button onClick={this.handleCloseAll}>Fechar</Button>
					</Modal.Footer>
				</Modal>


				<Modal show={this.state.showAlertSucces}>
					<Modal.Header style={{ background: '#D4EACA' }} closeButton>
						<Modal.Title style={{ color: '#4F844F' }}>Info.</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ background: '#D4EACA' }}>
						<p>{this.state.textAlertSucces}</p>
					</Modal.Body>
					<Modal.Footer style={{ background: '#D4EACA' }}>
						<Button onClick={this.handleCloseAll}>Fechar</Button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}


const mapStateToProps = state => ({
	rdUser: state.user
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(FormCliente))
